"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var InspectorCard = function InspectorCard(_ref) {
  var contactAvatar = _ref.contactAvatar,
      contactName = _ref.contactName,
      name = _ref.name,
      email = _ref.email,
      phone = _ref.phone,
      onOpen = _ref.onOpen;
  return /*#__PURE__*/_react["default"].createElement(_ui.ContactCard, {
    avatarUrl: contactAvatar,
    fullName: name,
    subheader: contactName,
    email: email,
    phone: phone,
    onClick: onOpen
  });
};

InspectorCard.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  avatarUrl: _propTypes["default"].string,
  fullName: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string
};
InspectorCard.defaultProps = {
  className: ''
};
var _default = InspectorCard;
exports["default"] = _default;